import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { DateFromDateOrIsoStringSchema } from "./date-schema";

const RedoFulfillmentToteSchema_ = z.object({
  _id: zExt.objectId(),
  createdAt: DateFromDateOrIsoStringSchema,
  updatedAt: DateFromDateOrIsoStringSchema,
  team: zExt.objectId(),
  name: z.string(),
  barcode: z.string(),
  barcodeUrl: z.string().nullish(),
  pickSessionId: z.string().nullish(),
  toteGroupId: zExt.objectId().nullish(),
  locationId: locationIdFormat.schema.nullish(),
});
export const RedoFulfillmentToteSchema: z.ZodType<RedoFulfillmentTote> =
  RedoFulfillmentToteSchema_;

export interface RedoFulfillmentTote extends z.infer<
  typeof RedoFulfillmentToteSchema_
> {}
